import "./libs/slick";
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {stickyHeader} from "./modules/stickyHeader";
import {mobileNav} from "./modules/mobileNav";
import {animationOnScroll} from "./modules/animationOnScroll";
import {bannersWithLinkSlider} from "./modules/bannersWithLinkSlider";
import {bannerSlider} from "./modules/bannerSlider";
import {productsSlider} from "./modules/productsSlider";
import {copyLinkToBuffer} from "./modules/copyLinkToBuffer";
import {anchors} from "./modules/anchors";
import {accordion} from "./modules/accordion";
import {winLocatioHash} from "./modules/winLocatioHash";
import {footerMobileNav} from "./modules/footerMobileNav";
import {mobileFilterOpener} from "./modules/mobileFilterOpener";
import {singleProductSlider} from "./modules/singleProductSlider";
import {customSelect} from "./modules/customSelect";
import {dashboardMobileNav} from "./modules/dashboardMobileNav";


binder({
    bounds: {
        html: [constants, fullHeightPage, winLocatioHash],
        ".header": [stickyHeader, mobileNav],
        ".footer-nav": footerMobileNav,
        ".banners-with-link.slider-on-mobile": bannersWithLinkSlider,
        ".banners-with-link.one-in-row.slider": bannerSlider,
        ".products-listing.slider .products": productsSlider,
        ".has-animation": animationOnScroll,
        ".copy-link": copyLinkToBuffer,
        ".has-anchor": anchors,
        ".accordion, .our-work-accordion": accordion,
        ".catalog-filters": mobileFilterOpener,
        ".product-images-gallery": singleProductSlider,
        "select, .jcf-scrollable": customSelect,
        ".dashboard-navigation-holder": dashboardMobileNav,
    },
    runTests: false
});




// WEBPACK FOOTER //
// ./assets/js/global.js